import React, { useEffect, useState } from 'react';
import { useParams} from 'react-router-dom';
import ChartDashboardViewr from './ChartDashboardViewr';
import ChartDashboardCreator from './ChartDashboardCreator';

import { ReactComponent as SaveIcon } from '../icons/home/save.svg';
import { ReactComponent as TrashIcon } from '../icons/home/trash.svg';
import { ReactComponent as CopyIcon } from '../icons/home/copy.svg';
import { ReactComponent as ExportIcon } from '../icons/home/export.svg';

import { API_BASE_URL, ItemList, fetchData, handleDuplicate, handleDelete, renderConfirmationModal, renderModal, closeModal, LoadingOverlay, Breadcrumbs } from './Common';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const IconButton = ({ Icon, action, dashboardId, permission, tooltip }) => {
  const isReadOnly = permission === 'read-only';

  return (
    <div className="tooltip" data-tooltip={tooltip}>
      <Icon
        onClick={() => !isReadOnly && action(dashboardId)}
        style={{
          cursor: isReadOnly ? 'not-allowed' : 'pointer',
          opacity: isReadOnly ? 0.5 : 1
        }}
        disabled={isReadOnly}
      />
    </div>
  );
};

//export-inicio----------------------------------------
const hideElements = (dashboardEl) => {
  const deleteButtons = dashboardEl.querySelectorAll(".delete-button1");
  const editButtons = dashboardEl.querySelectorAll(".edit-button1");
  const resizeHandles = dashboardEl.querySelectorAll(".react-resizable-handle");
  const theme1Borders = dashboardEl.querySelectorAll(".widget-container1");

  deleteButtons.forEach(el => (el.style.display = "none"));
  editButtons.forEach(el => (el.style.display = "none"));
  resizeHandles.forEach(el => (el.style.display = "none"));
  theme1Borders.forEach(el => {
    const borderStyle = el.style.border;
    if (borderStyle.includes("dashed")) {
      el.style.border = "none"; // hide dashed borders
    }
  });
  return { deleteButtons, editButtons, resizeHandles, theme1Borders };
};

const restoreElements = ({ deleteButtons, editButtons, resizeHandles, theme1Borders}) => {
  deleteButtons.forEach(el => (el.style.display = ""));
  editButtons.forEach(el => (el.style.display = ""));
  resizeHandles.forEach(el => (el.style.display = ""));
  theme1Borders.forEach(el => {
    if (el.style.border === "none") {
      el.style.border = "2px dashed #E6E9F0"; // restore theme 1 border
    }
  });
};

const exportDashboard = (type) => {
  const dashboardEl = document.querySelector(".react-grid-layout");
  if (!dashboardEl) return;

  const hiddenElements = hideElements(dashboardEl);

  // Get the bounding rectangle of the dashboard content
  const rect = dashboardEl.getBoundingClientRect();
  const width = rect.width;
  const height = rect.height;

  html2canvas(dashboardEl, {
    useCORS: true,
    scale: 2, // improves quality
    width: width,
    height: height,
    windowWidth: document.body.scrollWidth,
    windowHeight: document.body.scrollHeight
  }).then(canvas => {

    // create new canvas with margins
    const marginPx = 180;
    const canvasWithMargin = document.createElement("canvas");
    canvasWithMargin.width = canvas.width + marginPx * 2;
    canvasWithMargin.height = canvas.height + marginPx * 2;

    const ctx = canvasWithMargin.getContext("2d");

    // optional white background
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvasWithMargin.width, canvasWithMargin.height);

    // draw original canvas centered with margin
    ctx.drawImage(canvas, marginPx, marginPx);

    const imgData = canvasWithMargin.toDataURL("image/jpeg", 1.0);

    if (type === "jpg") {
      const link = document.createElement("a");
      link.download = "dashboard.jpg";
      link.href = imgData;
      link.click();
    }

    if (type === "pdf") {
  const pdf = new jsPDF('p', 'mm', 'a4'); // A4 portrait
  const pdfPageWidth = pdf.internal.pageSize.getWidth();
  const pdfPageHeight = pdf.internal.pageSize.getHeight();

  // Calculate width/height in mm for the PDF
  const imgProps = pdf.getImageProperties(imgData);
  const pdfWidth = pdfPageWidth;
  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

  if (pdfHeight <= pdfPageHeight) {
    // Fits on one page
    pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
  } else {
    // Dashboard is taller than one page, split across multiple pages
    let heightLeft = pdfHeight;
    let position = 0;

    while (heightLeft > 0) {
      pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pdfPageHeight;
      position -= pdfPageHeight;
      if (heightLeft > 0) pdf.addPage();
    }
  }

  pdf.save("dashboard.pdf");
}


    restoreElements(hiddenElements);
  });
};

//export-fim-----------------------------------------

function Project() {
  const { projectId } = useParams();
  const [tables, setTables] = useState([]);
  const [tableColumnData, setTableColumnData] = useState([]);
  const [isTableColumnDataLoaded, setIsTableColumnDataLoaded] = useState(false);
  const [isTablesLoaded, setIsTablesLoaded] = useState(false);

  const [isDuplicating, setIsDuplicating] = useState(false);
  const [spinnerMessage, setSpinnerMessage] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const [dashboardToDelete, setDashboardToDelete] = useState(null);
  const [dashboards, setDashboards] = useState([]);
  const [isDashboardsLoaded, setIsDashboardsLoaded] = useState(false);

  const [widgets, setWidgets] = useState([]);
  const [isWidgetsLoaded, setIsWidgetsLoaded] = useState(false);

  const [modalIconId, setModalIconId] = useState(0);

  const [showChartWidgetCreator, setShowChartWidgetCreator] = useState(false);

  const [projectName, setProjectName] = useState('');
  const [isProjectNameLoaded, setIsProjectNameLoaded] = useState(false);
  const [selectedWidgetId, setSelectedWidgetId] = useState(null);
  const [viewDashboardId, setviewDashboardId] = useState(null);

  const [exportModalVisible, setExportModalVisible] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // Track current page number
  const itemsPerPage = 10; // Maximum items per page

  const handleDashboardCreated = () => {
  setShowChartWidgetCreator(false);

  setModalMessage("Dashboard criado!");
  setModalMessageColor('#41BBC9');
  setModalIconId(1);
  setIsModalOpen(true);
};

  useEffect(() => {

    fetchData(`${API_BASE_URL}/project/${projectId}`, setProjectName, setIsProjectNameLoaded, 'name');

    fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsTablesLoaded, 'tables');

    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

    fetchData(`${API_BASE_URL}/widgets/${projectId}`, setWidgets, setIsWidgetsLoaded, 'widgetData');

    fetchData(`${API_BASE_URL}/dashboards/${projectId}`, setDashboards, setIsDashboardsLoaded, 'dashboardData');
  }, [projectId]); // Include projectId in the dependency array to refetch tables when projectId changes

const handleButtonClick = () => {
  if(selectedWidgetId) setSelectedWidgetId (null);
  else if(viewDashboardId) setviewDashboardId (null);
  else setShowChartWidgetCreator(prevState => !prevState); // Invert the state to show/hide ChartWidgetCreator
};

const confirmDeleteDashboard = async () => {
  setviewDashboardId(null);
  setModalIconId(0);
        const token = localStorage.getItem('token');
        await handleDelete('dashboards', null, dashboardToDelete, token, setDashboards, dashboards, setModalMessage, setModalMessageColor, setIsModalOpen, currentPage, setCurrentPage, itemsPerPage);
        setIsConfirmationModalOpen(false);
    };

    const handleExportDashboard = async (dashboardId) => {
    setviewDashboardId(dashboardId);
    setExportModalVisible(true);
  };

  const handleSaveLayout = async (tableId) => {
    setModalMessage("Dashboard guardado!");
    setModalMessageColor('#43BBC9');
    setModalIconId(3);
    setIsModalOpen(true);


  };

  const handleDownload = async (format) => {
        switch (format) {
          case 'JPG':
            exportDashboard("jpg");
            break;
          case 'PDF':
            exportDashboard("pdf");
            break;
          default:
            break;
    }
    setExportModalVisible(false);
  };

function ExportModal(visible, handleDownloadFunc, setModalVisibleFunc, showCSVOption) {

  const [selectedFormat, setSelectedFormat] = useState('PDF');
  const [urlSharingEnabled, setUrlSharingEnabled] = useState(false);

  useEffect(() => {
    setUrlSharingEnabled(dashboards[viewDashboardId]?.URLshare || false);
  }, []);


  const handleCheckboxChange = (format) => {
    if (selectedFormat !== format) {
      setSelectedFormat(format);
    }
  };

  const generateShareableUrl = () => {
    return `${window.location.origin}/${projectId}/${viewDashboardId}/${dashboards[viewDashboardId]?.share_code}`;
  };
  //requere https
  /*const handleCopyUrl = () => {
    const url = generateShareableUrl();
    navigator.clipboard.writeText(url).then(() => {
      alert('URL copiado para o clipboard');
    }).catch((err) => {
      console.error('Failed to copy URL: ', err);
    });
  };*/
  const handleCopyUrl = () => {
    const url = generateShareableUrl();

    // Create a temporary input element
    const tempInput = document.createElement('input');
    tempInput.value = url;

    // Append to the document and select the text
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // for mobile devices

    try {
        document.execCommand('copy');
        alert('URL copiado para o clipboard');
    } catch (err) {
        console.error('Failed to copy URL: ', err);
    }

    // Clean up by removing the temporary input
    document.body.removeChild(tempInput);
};


  const handleUrlToggle = async (enabled,dashboardId) => {
  setUrlSharingEnabled(enabled);

  const response = await fetch(`${API_BASE_URL}/dashboards/${dashboardId}/toggle-sharing`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}` // Assuming token is stored in localStorage
      },
      body: JSON.stringify({ isShared: enabled })
    });

  if (response.ok) {
      //setSharingEnabled(newSharingStatus); // Update local state
    } else {
      console.error('Failed to update sharing status');
    }
  };

  return (
  visible && (
    <div
      className="modal-overlay"
      onClick={() => setModalVisibleFunc(false)}
    >
      <div
        className="export-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <ExportIcon />
        <span
          className="close"
          onClick={() => setModalVisibleFunc(false)}
        >
          &times;
        </span>

        <p className="modal-title">Exportar dados</p>
        <p className="modal-intro">Selecionar formato</p>

        <div>
          {showCSVOption && (
            <div className="toggle-copy-container">
              <label className="toggle-switch">
                <span>Partilhar URL</span>
                <input
                  type="checkbox"
                  checked={urlSharingEnabled}
                  onChange={() =>
                    handleUrlToggle(!urlSharingEnabled, viewDashboardId)
                  }
                />
                <span className="slider"></span>
              </label>

              {urlSharingEnabled && (
                <button
                  className="copy-url-btn"
                  onClick={handleCopyUrl}
                >
                  <span>Copiar URL</span>
                </button>
              )}
            </div>
          )}

          <label>
            <input
              type="checkbox"
              value="JPG"
              checked={selectedFormat === 'JPG'}
              onChange={() => handleCheckboxChange('JPG')}
            />
            <span>JPG</span>
          </label>

          <label>
            <input
              type="checkbox"
              value="PDF"
              checked={selectedFormat === 'PDF'}
              onChange={() => handleCheckboxChange('PDF')}
            />
            <span>PDF</span>
          </label>
        </div>

        <button onClick={() => handleDownloadFunc(selectedFormat)}>
          <span>Download</span>
        </button>
      </div>
    </div>
  )
);

}

const handleDuplicateDashboard = (dashboardId) => {
  handleDuplicate(
    'dashboard',
    dashboardId,
    setDashboards,
    dashboards,
    'Dashboard Duplicado!',
    setIsDuplicating,
    setModalMessage,
    setModalMessageColor,
    setIsModalOpen,
    setWidgets,
    widgets
  );
};

const handleDeleteClick = (dashboardId) => {
  setDashboardToDelete(dashboardId);
  setIsConfirmationModalOpen(true);
    };

  const hasReadOnlyPermission = Object.values(tables).some(table => table.permission === 'read-only');

  return (
  <div className="home-container">

  <Breadcrumbs
  items={
    viewDashboardId
      ? [
          { label: "Projetos", path: "/home" },
          { label: projectName, path: `/project/${projectId}/dados` },
          {
            label: "Dashboards",
            onClick: () => setviewDashboardId(null),
          },
          { label: dashboards[viewDashboardId]?.name || "Dashboard" },
        ]
      : showChartWidgetCreator
      ? [
          { label: "Projetos", path: "/home" },
          { label: projectName, path: `/project/${projectId}/dados` },
          {
            label: "Dashboards",
            onClick: () => setShowChartWidgetCreator(false), // reset create view
          },
          { label: "Criar Dashboard" },
        ]
      : [
          { label: "Projetos", path: "/home" },
          { label: projectName, path: `/project/${projectId}/dados` },
          { label: "Dashboards" },
        ]
  }
/>
  {!showChartWidgetCreator &&  (<>
    {viewDashboardId && (
<div className="button-container">
  <div className="icons-container" style={{ display: 'flex', gap: '35px' }}>

    <IconButton
      Icon={SaveIcon}
      action={handleSaveLayout}
      dashboardId={viewDashboardId}
      permission={dashboards[viewDashboardId]?.permission}
      tooltip="Guardar"
    />

    <IconButton
      Icon={TrashIcon}
      action={handleDeleteClick}
      dashboardId={viewDashboardId}
      permission={dashboards[viewDashboardId]?.permission}
      tooltip="Eliminar"
    />

    <IconButton
      Icon={CopyIcon}
      action={handleDuplicateDashboard}
      dashboardId={viewDashboardId}
      permission={dashboards[viewDashboardId]?.permission}
      tooltip="Duplicar"
    />

    <div className="tooltip" data-tooltip="Exportar">
      <ExportIcon
        onClick={() => handleExportDashboard(viewDashboardId)}
        style={{ cursor: 'pointer' }}
      />
    </div>

  </div>
</div>
)}
    <p className="text0">
      {viewDashboardId ? "Editar Dashboard" : "Dashboards"}
    </p>
    <p>
      {viewDashboardId
        ? `Construa e personalize o seu dashboard ao arrastar e ajustar elementos`
        : "Acesso à lista de todos dashboards do projeto"}
    </p>

    <p className="text1">{/* {projectName} */}</p>


    {!viewDashboardId && (
    <ItemList
      tipo="dashboard"
      isLoaded={isTableColumnDataLoaded}
      onEdit={setviewDashboardId}
      onExport={handleExportDashboard}
      onDelete={handleDeleteClick}
      onDuplicate={handleDuplicateDashboard}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      DataArray={dashboards}
      itemsPerPage={itemsPerPage}
      />
)}
</>)}

{renderConfirmationModal(isConfirmationModalOpen, "Tem a certeza que pretende eliminar o dashboard?", confirmDeleteDashboard, () => setIsConfirmationModalOpen(false))}

{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}

{ExportModal(exportModalVisible, handleDownload, setExportModalVisible, true)}

<div>

{!viewDashboardId && !selectedWidgetId && !showChartWidgetCreator && (
  <div className="button-container">
    <button
      className="button"
      onClick={handleButtonClick}
      style={{
        cursor: !isTablesLoaded || hasReadOnlyPermission ? 'not-allowed' : 'pointer',
        opacity: !isTablesLoaded || hasReadOnlyPermission ? 0.5 : 1,
      }}
      disabled={!isTablesLoaded || hasReadOnlyPermission}
    >
      Criar Dashboard
    </button>
  </div>
)}


{!selectedWidgetId && viewDashboardId && (

  <>
    {(() => {

      return (
      <ChartDashboardViewr
        widgets={widgets}
        tables={tables}
        dashboard={dashboards[viewDashboardId]}
        DashboardId={viewDashboardId}
        permission={dashboards[viewDashboardId].permission}
        setDashboards={setDashboards}
        setWidgets={setWidgets}
        setIsWidgetsLoaded={setIsWidgetsLoaded}
        setIsDashboardsLoaded={setIsDashboardsLoaded}
        projectId={projectId}
        setIsDuplicating={setIsDuplicating}
        setSpinnerMessage={setSpinnerMessage}
        onSave={handleSaveLayout}
        onDelete={handleDeleteClick}
        onDuplicate={handleDuplicateDashboard}
        onExport={handleExportDashboard}
        isTablesLoaded={isTablesLoaded}

tableColumnData={tableColumnData}
      />
      );
    })()}
  </>
)}

{showChartWidgetCreator && (
      <ChartDashboardCreator
        tableColumnData={tableColumnData}
        isTablesLoaded={isTablesLoaded}
        projectId={projectId}
        setDashboards={setDashboards}
  setIsDashboardsLoaded={setIsDashboardsLoaded}
  setWidgets={setWidgets}
  setIsWidgetsLoaded={setIsWidgetsLoaded}
  onDashboardCreated={handleDashboardCreated}
      />
)}

</div>

<LoadingOverlay isDuplicating={isDuplicating} spinnerMessage={spinnerMessage}/>

</div>
);

}

export default Project;
